import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import { generateSurveyMetrics } from '../../utilityFunctions/DataloveUtil';
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";

export default function DonutChart(props) {
    const { loginUser } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [completionRate, setCompletionRate] = useState(0);

    useEffect(() => {
        const fetchSurveyMetrics = async () => {
            setLoading(true);
            const surveyMetrics = await generateSurveyMetrics(loginUser.jwtToken);
            setLoading(false);

            if (!surveyMetrics) {
                Swal({
                    title: "Error",
                    text: "Failed to fetch survey metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            const completed = surveyMetrics.completedSurveys || 0;
            const total = surveyMetrics.totalSurveys || 0;
            const rate = total > 0 ? (completed / total) * 100 : 0;
            
            setCompletionRate(rate);
            
            const chartData = [
                { name: 'Completed', value: completed },
                { name: 'Incomplete', value: total - completed }
            ];
            
            setData(chartData);
        };
        fetchSurveyMetrics();
    }, [loginUser.jwtToken]);

    // Colors for the donut chart
    const COLORS = ['#4a3596', '#f2736a'];

    // Custom tooltip
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                    <p>{`${payload[0].name}: ${payload[0].value}`}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                ) : (
                    <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>Survey Completion Rate</Typography>
                        </Grid>
                        {data && data.length > 0 ? (
                            <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <PieChart>
                                        <Pie
                                            data={data}
                                            cx="50%"
                                            cy="50%"
                                            innerRadius={60}
                                            outerRadius={100}
                                            fill="#8884d8"
                                            paddingAngle={5}
                                            dataKey="value"
                                            label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                                        >
                                            {data.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <Tooltip content={<CustomTooltip />} />
                                        <Legend />
                                    </PieChart>
                                </ResponsiveContainer>
                                <Typography variant="h6" sx={{ marginTop: "-25rem", fontWeight: "bold" }}>
                                    {completionRate.toFixed(1)}%
                                </Typography>
                                <Typography variant="body1" sx={{ marginTop: "0.5rem" }}>
                                    Completion Rate
                                </Typography>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    No data available.
                                </Typography>                                
                            </Grid>
                        )}
                    </Grid>
                )}           
            </Box>
        </Box>
    );
} 